import React from 'react';
import '../template-file-css/document-file-template.css';


export const OABS_AdultSubstanceAssessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='OABS_AdultSubstanceAssessment' className='file-pdf-document'>

            <div className='file-template'> 
            <p className='w-750'>
                    <span className="eleHeader">Weekly Family Take Home Income:</span>
                    <select id='ddWeeklyFamilyTakeHomeIncome' name='ddWeeklyFamilyTakeHomeIncome' className='add-only'>
                        <option value="0">*Choose*</option>
                        <option value="1">Prefer not to answer</option>
                        <option value="2">$0</option>
                        <option value="3">Less than $200</option>
                        <option value="4">$200-$300</option>
                        <option value="5">$301-$400</option>
                        <option value="6">$401-$500</option>
                        <option value="7">$501-$600</option>
                        <option value="8">$601-$700</option>
                        <option value="9">$701-$800</option>
                        <option value="10">$801-$900</option>
                        <option value="11">Over $900</option>
                        <option value="12">Not Sure</option>
                    </select>
                </p>
                <table>
                    <tr>
                        <td className='w-600'></td>
                        <td className='w-75'>
                            <span className='eleHeader'>TRUE </span>
                        </td>
                        <td className='w-75'>
                            <span className='eleHeader'>FALSE </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            (1) Most people would lie to get what they want</td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_1' name='rbMostPeopleWouldLieToGetWhatTheyWant' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_1' name='rbMostPeopleWouldLieToGetWhatTheyWant' className='add-only' value='False' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            (2) Most people make some mistakes in their life
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_2' name='rbMostPeopleMakeSomeMistakesInTheirLife' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_2' name='rbMostPeopleMakeSomeMistakesInTheirLife' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (3) I usually "go along" and do what others are doing.
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_3' name='rbUsuallyGoAlongAndDoWhatOthersAreDoing' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_3' name='rbUsuallyGoAlongAndDoWhatOthersAreDoing' className='add-only' value='False' /> </center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (4) I have never been in trouble with the police
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_4' name='rbHaveNeverBeenInTroubleWithThePolice' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_4' name='rbHaveNeverBeenInTroubleWithThePolice' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (5) I was always well behaved in school
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_5' name='rbWasAlwaysWellBehavedInSchool' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_5' name='rbWasAlwaysWellBehavedInSchool' className='add-only' value='False' /> </center></td>


                    </tr>
                    <tr>
                        <td className='w-600'>
                            (6)  My troubles are not all my fault
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_6' name='rbMyTroublesAreNotAllMyFault' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_6' name='rbMyTroublesAreNotAllMyFault' className='add-only' value='False' /> </center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (7)  I have not lived the way I should
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_7' name='rbHaveNotLivedTheWayShould' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_7' name='rbHaveNotLivedTheWayShould' className='add-only' value='False' /></center></td>


                    </tr>
                    <tr>
                        <td className='w-600'>
                            (8) I can be friendly with people who do many wrong things
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_8' name='rbFriendlyWithPeopleWhoDoManyWrongThings' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_8' name='rbFriendlyWithPeopleWhoDoManyWrongThings' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (9) I do not like to sit and daydream
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_9' name='rbDoNotLikeToSitAndDaydream' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_9' name='rbDoNotLikeToSitAndDaydream' className='add-only' value='False' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            (10) No one has ever criticized or punished me</td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_10' name='rbNoOneHasEverCriticizedOrPunishedMe' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_10' name='rbNoOneHasEverCriticizedOrPunishedMe' className='add-only' value='False' /> </center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (11)  Sometimes I have a hard time sitting still
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_11' name='rbSometimesHaveHardTimeSittingStill' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_11' name='rbSometimesHaveHardTimeSittingStill' className='add-only' value='False' /></center></td>


                    </tr>
                    <tr>
                        <td className='w-600'>
                            (12)  People would be better off if they took my advice
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_12' name='rbPeopleWouldBeBetterOffIfTheyTookAdvice' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_12' name='rbPeopleWouldBeBetterOffIfTheyTookAdvice' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (13)   At times I feel worn out for no special reason
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_13' name='rbAtTimesFeelWornOutForNoSpecialReason' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_13' name='rbAtTimesFeelWornOutForNoSpecialReason' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (14)  I think I would enjoy moving to an area I've never been before
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_14' name='rbThinkWouldEnjoyMovinToArea' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_14' name='rbThinkWouldEnjoyMovinToArea' className='add-only' value='False' /> </center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (15)  It is better not to talk about personal problems
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_15' name='rbItIsBetterNotTalkAboutPersonalProblems' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_15' name='rbItIsBetterNotTalkAboutPersonalProblems' className='add-only' value='False' /></center></td>


                    </tr>
                    <tr>
                        <td className='w-600'>
                            (16)  Nearly everyone enjoys being picked on or made fun of
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_16' name='rbNearlyEveryoneEnjoysBeingPickedOnOrMadeFunOf' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_16' name='rbNearlyEveryoneEnjoysBeingPickedOnOrMadeFunOf' className='add-only' value='False' /> </center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (17) I have had days, weeks or months when I couldn't get much done because I just wasn't up to it
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_17' name='rbHaveHadDaysWeeksOrMonthsWhenCould' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_17' name='rbHaveHadDaysWeeksOrMonthsWhenCould' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (18)  I am very respectful of authority
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_18' name='rbAmVeryRespectfulOfAuthority' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_18' name='rbAmVeryRespectfulOfAuthority' className='add-only' value='False' /> </center></td>


                    </tr>
                    <tr>
                        <td className='w-600'>
                            (19)  I like to obey the law
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_19' name='rbLikeToObeyTheLaw' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_19' name='rbLikeToObeyTheLaw' className='add-only' value='False' /> </center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (20) I have been tempted to leave home
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_20' name='rbHaveBeenTemptedToLeaveHome' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_20' name='rbHaveBeenTemptedToLeaveHome' className='add-only' value='False' /> </center></td>


                    </tr>
                    <tr>
                        <td className='w-600'>
                            (21) I often feel that strangers look at me with disapproval
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_21' name='rbOftenFeelThatStrangersLookAtMeWithDisapproval' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_21' name='rbOftenFeelThatStrangersLookAtMeWithDisapproval' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (22)  Other people would fall apart if they had to deal with what I handle </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_22' name='rbOtherPeopleWouldFallApartIfTheyHadToDealWithWhatHandle' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_22' name='rbOtherPeopleWouldFallApartIfTheyHadToDealWithWhatHandle' className='add-only' value='False' /> </center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (23)  I have avoided people I did not wish to speak to
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_23' name='rbHaveAvoidedPeopleDidNotWishToSpeakTo' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_23' name='rbHaveAvoidedPeopleDidNotWishToSpeakTo' className='add-only' value='False' /> </center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (24)  Some crooks are so clever that I hope they get away with what they have done
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_24' name='rbSomeCrooksAreSoCleverThatHopeTheyGetAwayWithWhatTheyHaveDone' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_24' name='rbSomeCrooksAreSoCleverThatHopeTheyGetAwayWithWhatTheyHaveDone' className='add-only' value='False' /></center></td>


                    </tr>
                    <tr>
                        <td className='w-600'>
                            (25) My school teachers had some problems with me
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_25' name='rbQuestion_1' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_25' name='rbQuestion_1' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (26)  I have never done anything dangerous just for fun
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_26' name='rbQuestion_2' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_26' name='rbQuestion_2' className='add-only' value='False' /></center></td>


                    </tr>
                    <tr>
                        <td className='w-600'>
                            (27)  I need to have something to do so I don't get bored
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_27' name='rbQuestion_3' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_27' name='rbQuestion_3' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (28)  I have sometimes drunk too much
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_28' name='rbQuestion_4' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_28' name='rbQuestion_4' className='add-only' value='False' /></center></td>


                    </tr>
                    <tr>
                        <td className='w-600'>
                            (29)  Much of my life is uninteresting
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_29' name='rbQuestion_5' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_29' name='rbQuestion_5' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (30)  Sometimes I wish I could control myself better
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_30' name='rbQuestion_6' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_30' name='rbQuestion_6' className='add-only' value='False' /></center></td>


                    </tr>
                    <tr>
                        <td className='w-600'>
                            (31) I believe that people sometimes get confused
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_31' name='rbQuestion_7' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_31' name='rbQuestion_7' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (32) Sometimes I am no good for anything at all
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_32' name='rbQuestion_8' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_32' name='rbQuestion_8' className='add-only' value='False' /></center></td>


                    </tr>
                    <tr>
                        <td className='w-600'>
                            (33) I break more laws that many people
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_33' name='rbQuestion_9' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_33' name='rbQuestion_9' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (34)  If some friends and I were in trouble together, I would rather take the whole blame than tell on them
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_34' name='rbQuestion_10' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_34' name='rbQuestion_10' className='add-only' value='False' /></center></td>


                    </tr>
                    <tr>
                        <td className='w-600'>
                            (35) Crying does not help anything
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_35' name='rbQuestion_11' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_35' name='rbQuestion_11' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (36)  I think there is something wrong with my memory
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_36' name='rbQuestion_12' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_36' name='rbQuestion_12' className='add-only' value='False' /></center></td>


                    </tr>
                    <tr>
                        <td className='w-600'>
                            (37) I have sometimes been tempted to hit people
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_37' name='rbQuestion_13' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_37' name='rbQuestion_13' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (38) My most important successes are not a direct result of my effort
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_38' name='rbQuestion_14' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_38' name='rbQuestion_14' className='add-only' value='False' /></center></td>


                    </tr>
                    <tr>
                        <td className='w-600'>
                            (39)  I always feel sure of myself
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_39' name='rbQuestion_15' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_39' name='rbQuestion_15' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (40) I have never broken a major law
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_40' name='rbQuestion_16' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_40' name='rbQuestion_16' className='add-only' value='False' /></center></td>


                    </tr>
                    <tr>
                        <td className='w-600'>
                            (41) There have been times when I have done things I couldn't remember later.
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_41' name='rbQuestion_17' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_41' name='rbQuestion_17' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (42) I think carefully about all my actions
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_42' name='rbQuestion_18' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_42' name='rbQuestion_18' className='add-only' value='False' /></center></td>


                    </tr>
                    <tr>
                        <td className='w-600'>
                            (43) I have used alcohol or "pot" too much or too often.
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_43' name='rbQuestion_19' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_43' name='rbQuestion_19' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (44) I know who is to blame for most of my troubles
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_44' name='rbQuestion_20' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_44' name='rbQuestion_20' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (45) I frequently make lists of things to do
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_45' name='rbQuestion_21' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_45' name='rbQuestion_21' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (46) I guess I know some pretty undesirable types
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_46' name='rbQuestion_22' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_46' name='rbQuestion_22' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (47) Most people will laugh at a joke at times
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_47' name='rbQuestion_23' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_47' name='rbQuestion_23' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (48) I have rarely been punished
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_48' name='rbQuestion_24' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_48' name='rbQuestion_24' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (49) I smoke cigarettes regularly
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_49' name='rbQuestion_25' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_49' name='rbQuestion_25' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (50) At times, I have been so full of energy that I felt I didn't need sleep for days at a time
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_50' name='rbQuestion_26' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_50' name='rbQuestion_26' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (51) I have sometimes sat about when I should have been working
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_51' name='rbQuestion_27' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_51' name='rbQuestion_27' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (52) I am often resentful</td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_52' name='rbQuestion_28' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_52' name='rbQuestion_28' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (53) I take all my responsibilities seriously
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_53' name='rbQuestion_29' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_53' name='rbQuestion_29' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (54) I have neglected obligations to family or work because of drinking or using drugs
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_54' name='rbQuestion_30' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_54' name='rbQuestion_30' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (55) I have had a drink first thing in the morning to steady my nerves or get rid of a hangover
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_55' name='rbQuestion_31' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_55' name='rbQuestion_31' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (56) While I was a teenager, I began drinking or using other drugs regularly
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_56' name='rbQuestion_32' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_56' name='rbQuestion_32' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (57) My father was/is a heavy drinker or drug user.
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_57' name='rbQuestion_33' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_57' name='rbQuestion_33' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (58) When I drink or use drugs I tend to get in trouble
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_58' name='rbQuestion_34' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_58' name='rbQuestion_34' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (59) My drinking or other drug use causes problems between me and my family
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_59' name='rbQuestion_35' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_59' name='rbQuestion_35' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (60) I do most of my drinking or drug using away from home
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_60' name='rbQuestion_36' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_60' name='rbQuestion_36' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (61) At least once a week, I use some non-prescription antacid and/or diarrhea medicine.
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_61' name='rbQuestion_37' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_61' name='rbQuestion_37' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (62) I have never felt sad over anything.
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_62' name='rbQuestion_38' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_62' name='rbQuestion_38' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (63) I am rarely at a loss for words.
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_63' name='rbQuestion_39' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_63' name='rbQuestion_39' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (64) I am usually happy. </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_64' name='rbQuestion_40' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_64' name='rbQuestion_40' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (65) I am a restless person.
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_65' name='rbQuestion_41' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_65' name='rbQuestion_41' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (66) I like doing things on the spur of the moment.
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_66' name='rbQuestion_42' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_66' name='rbQuestion_42' className='add-only' value='False' /></center></td>

                    </tr>
                    <tr>
                        <td className='w-600'>
                            (67) I am a binge drinker/drug use.
                        </td>
                        <td className='w-75'><center><input type='radio' id='rbTrue_67' name='rbQuestion_43' className='add-only' value='True' /></center></td>
                        <td className='w-75'><center><input type='radio' id='rbFalse_67' name='rbQuestion_43' className='add-only' value='False' /></center></td>
                    </tr>
                </table>
                <p className='w-750'>For each item below, select the number which reflects how often you have experienced the situation during:</p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbYourEntireLife' name='rbForEachaItemsBelowSelectTheNumbersWhichReflects' className='add-only' value='YourEntireLife' /> Your Entire Life
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbThePastMOnths' name='rbForEachaItemsBelowSelectTheNumbersWhichReflects' className='add-only' value='ThePastMOnths' /> The Past 6 MOnths
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTheMonthsBefore' name='rbForEachaItemsBelowSelectTheNumbersWhichReflects' className='add-only' value='TheMonthsBefore' /> The 6 Months Before&nbsp;
                            <input type='text' id='txtTheMonthsBefore' name='txtTheMonthsBefore' placeholder='' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTheMonthsAfter' name='rbForEachaItemsBelowSelectTheNumbersWhichReflects' className='add-only' value='TheMonthsAfter' /> The 6 Months After&nbsp;
                            <input type='text' id='txtTheMonthsAfter' name='txtTheMonthsAfter' placeholder='' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>

                        <td className='w-320'>
                            <span className='eleHeader'>ALCOHOL (FVA)</span>
                        </td>
                        <td className='w-75'>
                            <span className='eleHeader'>NEVER</span>
                        </td>
                        <td className='w-130'>
                            <span className='eleHeader'>ONCE OR TWICE</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>SEVERAL TIMES</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>REPEATEDLY</span>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-320'>
                            (1) Had drinks with lunch?</td>
                        <td className='w-75'> <center><input type='radio' id='rbAlcoholNever_1' name='rbAlcoholFva_1' className='add-only' value='Never' /></center></td>
                        <td className='w-130'><center><input type='radio' id='rbAlcoholOnceOrTwice_1' name='rbAlcoholFva_1' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbAlcoholSeveralTimes_1' name='rbAlcoholFva_1' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbAlcoholRepeatedly_1' name='rbAlcoholFva_1' className='add-only' value='Repeatedly' /></center> </td>
                    </tr>
                    <tr>
                        <td className='w-320'>
                            (2) Taken a drink or drinks to help you express your feelings or ideas? </td>
                        <td className='w-75'><center><input type='radio' id='rbAlcoholNever_2' name='rbAlcoholFva_2' className='add-only' value='Never' /></center> </td>
                       <td className='w-130'><center><input type='radio' id='rbAlcoholOnceOrTwice_2' name='rbAlcoholFva_2' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbAlcoholSeveralTimes_2' name='rbAlcoholFva_2' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbAlcoholRepeatedly_2' name='rbAlcoholFva_2' className='add-only' value='Repeatedly' /></center> </td>

                    </tr>
                    <tr>
                        <td className='w-320'>
                            (3)  Taken a drink or drinks to relieve a tired feeling or give you energy to keep going? </td>
                        <td className='w-75'><center><input type='radio' id='rbAlcoholNever_3' name='rbAlcoholFva_3' className='add-only' value='Never' /></center> </td>
                       <td className='w-130'><center><input type='radio' id='rbAlcoholOnceOrTwice_3' name='rbAlcoholFva_3' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbAlcoholSeveralTimes_3' name='rbAlcoholFva_3' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbAlcoholRepeatedly_3' name='rbAlcoholFva_3' className='add-only' value='Repeatedly' /></center> </td>
                    </tr>
                    <tr>
                        <td className='w-320'>
                            (4)  Had more to drink than you intended to?</td>
                        <td className='w-75'><center><input type='radio' id='rbAlcoholNever_4' name='rbAlcoholFva_4' className='add-only' value='Never' /></center> </td>
                       <td className='w-130'><center><input type='radio' id='rbAlcoholOnceOrTwice_4' name='rbAlcoholFva_4' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbAlcoholSeveralTimes_4' name='rbAlcoholFva_4' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbAlcoholRepeatedly_4' name='rbAlcoholFva_4' className='add-only' value='Repeatedly' /></center> </td>
                    </tr>
                    <tr>
                        <td className='w-320'>
                            (5)  Experienced physical problems after drinking (e.g. nausea, seeing/hearing problems,dizziness, etc.)?</td>
                        <td className='w-75'><center><input type='radio' id='rbAlcoholNever_5' name='rbAlcoholFva_5' className='add-only' value='Never' /></center> </td>
                       <td className='w-130'><center><input type='radio' id='rbAlcoholOnceOrTwice_5' name='rbAlcoholFva_5' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbAlcoholSeveralTimes_5' name='rbAlcoholFva_5' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbAlcoholRepeatedly_5' name='rbAlcoholFva_5' className='add-only' value='Repeatedly' /></center> </td>


                    </tr>
                    <tr>
                        <td className='w-320'>
                            (6)  Gotten into trouble on the job, in school or at home because of drinking? </td>
                        <td className='w-75'><center><input type='radio' id='rbAlcoholNever_6' name='rbAlcoholFva_6' className='add-only' value='Never' /></center> </td>
                       <td className='w-130'><center><input type='radio' id='rbAlcoholOnceOrTwice_6' name='rbAlcoholFva_6' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbAlcoholSeveralTimes_6' name='rbAlcoholFva_6' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbAlcoholRepeatedly_6' name='rbAlcoholFva_6' className='add-only' value='Repeatedly' /></center> </td>

                    </tr>
                    <tr>
                        <td className='w-320'>
                            (7)  Become depressed after having sobered up? </td>
                        <td className='w-75'><center><input type='radio' id='rbAlcoholNever_7' name='rbAlcoholFva_7' className='add-only' value='Never' /></center> </td>
                       <td className='w-130'><center><input type='radio' id='rbAlcoholOnceOrTwice_7' name='rbAlcoholFva_7' className='add-only' value='OnceOrTwice' /></center> </td>
                       <td className='w-125'><center><input type='radio' id='rbAlcoholSeveralTimes_7' name='rbAlcoholFva_7' className='add-only' value='SeveralTimes' /></center> </td>
                       <td className='w-100'><center><input type='radio' id='rbAlcoholRepeatedly_7' name='rbAlcoholFva_7' className='add-only' value='Repeatedly' /></center> </td>
                    </tr>
                    <tr>
                        <td className='w-320'>
                            (8)  Argued with your family or friends because of your drinking</td>
                        <td className='w-75'><center><input type='radio' id='rbAlcoholNever_8' name='rbAlcoholFva_8' className='add-only' value='Never' /></center> </td>
                       <td className='w-130'><center><input type='radio' id='rbAlcoholOnceOrTwice_8' name='rbAlcoholFva_8' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbAlcoholSeveralTimes_8' name='rbAlcoholFva_8' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbAlcoholRepeatedly_8' name='rbAlcoholFva_8' className='add-only' value='Repeatedly' /></center> </td>
                    </tr>
                    <tr>
                        <td className='w-320'>
                            (9) Had the effects of drinking recur after not drinking for a while (e.g. flashbacks, etc.)??</td>
                        <td className='w-75'><center><input type='radio' id='NrbAlcoholNever_9' name='rbAlcoholFva_9' className='add-only' value='Never' /></center> </td>
                       <td className='w-130'><center><input type='radio' id='rbAlcoholOnceOrTwice_9' name='rbAlcoholFva_9' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbAlcoholSeveralTimes_9' name='rbAlcoholFva_9' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbAlcoholRepeatedly_9' name='rbAlcoholFva_9' className='add-only' value='Repeatedly' /></center> </td>


                    </tr>
                    <tr>
                        <td className='w-320'>
                            (10) Had problems in relationships becaus of your drinking (e.g. loss of friends, divorce,etc.)?</td>
                        <td className='w-75'><center><input type='radio' id='rbAlcoholNever_10' name='rbAlcoholFva_10' className='add-only' value='Never' /></center> </td>
                       <td className='w-130'><center><input type='radio' id='rbAlcoholOnceOrTwice_10' name='rbAlcoholFva_10' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbAlcoholSeveralTimes_10' name='rbAlcoholFva_10' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbAlcoholRepeatedly_10' name='rbAlcoholFva_10' className='add-only' value='Repeatedly' /></center> </td>

                    </tr>
                    <tr>
                        <td className='w-320'>
                            (11)  Become nervous or had the shakes after having sobered up?</td>
                        <td className='w-75'><center><input type='radio' id='rbAlcoholNever_11' name='rbAlcoholFva_11' className='add-only' value='Never' /></center> </td>
                       <td className='w-130'><center><input type='radio' id='rbAlcoholOnceOrTwice_11' name='rbAlcoholFva_11' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbAlcoholSeveralTimes_11' name='rbAlcoholFva_11' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbAlcoholRepeatedly_11' name='rbAlcoholFva_11' className='add-only' value='Repeatedly' /></center> </td>


                    </tr>
                    <tr>
                        <td className='w-320'>
                            (12)  Tried to commit suicide while drunk?</td>
                        <td className='w-75'><center><input type='radio' id='rbAlcoholNever_12' name='rbAlcoholFva_12' className='add-only' value='Never' /></center> </td>
                       <td className='w-130'><center><input type='radio' id='rbAlcoholOnceOrTwice_12' name='rbAlcoholFva_12' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbAlcoholSeveralTimes_12' name='rbAlcoholFva_12' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbAlcoholRepeatedly_12' name='rbAlcoholFva_12' className='add-only' value='Repeatedly' /></center> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-320'>
                            <span className='eleHeader'>OTHER DRUGS (FVOD)</span>
                        </td>
                        <td className='w-75'>
                            <span className='eleHeader'>NEVER</span>
                        </td>
                        <td className='w-130'>
                            <span className='eleHeader'>ONCE OR TWICE</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>SEVERAL TIMES</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>REPEATEDLY</span>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-320'>
                            (1)  Taken drugs to improve your thinking and feeling?</td>
                        <td className='w-75'><center><input type='radio' id='rbOtherDrugsNever_1' name='rbOtherDrugs_1' className='add-only' value='Never' /></center> </td>
                        <td className='w-130'><center><input type='radio' id='rbOtherDrugsOnceOrTwice_1' name='rbOtherDrugs_1' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbOtherDrugsSeveralTimes_1' name='rbOtherDrugs_1' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbOtherDrugsRepeatedly_1' name='rbOtherDrugs_1' className='add-only' value='Repeatedly' /></center> </td>


                    </tr>
                    <tr>
                        <td className='w-320'>
                            (2)  Taken drugs to help you feel better about a problem?</td>
                        <td className='w-75'><center><input type='radio' id='rbOtherDrugsNever_2' name='rbOtherDrugs_2' className='add-only' value='Never' /></center> </td>
                         <td className='w-130'><center><input type='radio' id='rbOtherDrugsOnceOrTwice_2' name='rbOtherDrugs_2' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbOtherDrugsSeveralTimes_2' name='rbOtherDrugs_2' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbOtherDrugsRepeatedly_2' name='rbOtherDrugs_2' className='add-only' value='Repeatedly' /></center> </td>

                    </tr>
                    <tr>
                        <td className='w-320'>
                            (3) Taken drugs to become more aware of your senses (e.g. sight, hearing,touch, etc.)?</td>
                        <td className='w-75'><center><input type='radio' id='rbOtherDrugsNever_3' name='rbOtherDrugs_3' className='add-only' value='Never' /></center> </td>
                         <td className='w-130'><center><input type='radio' id='rbOtherDrugsOnceOrTwice_3' name='rbOtherDrugs_3' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbOtherDrugsSeveralTimes_3' name='rbOtherDrugs_3' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbOtherDrugsRepeatedly_3' name='rbOtherDrugs_3' className='add-only' value='Repeatedly' /></center> </td>

                    </tr>
                    <tr>
                        <td className='w-320'>
                            (4)  Taken drugs to imporive your enjoyment of sex?</td>
                        <td className='w-75'><center><input type='radio' id='rbOtherDrugsNever_4' name='rbOtherDrugs_4' className='add-only' value='Never' /></center> </td>
                         <td className='w-130'><center><input type='radio' id='rbOtherDrugsOnceOrTwice_4' name='rbOtherDrugs_4' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbOtherDrugsSeveralTimes_4' name='rbOtherDrugs_4' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbOtherDrugsRepeatedly_4' name='rbOtherDrugs_4' className='add-only' value='Repeatedly' /></center> </td>

                    </tr>
                    <tr>
                        <td className='w-320'>
                            (5)  Taken drugs to help forget that you feel helpless or unworthy?</td>
                        <td className='w-75'><center><input type='radio' id='rbOtherDrugsNever_5' name='rbOtherDrugs_5' className='add-only' value='Never' /></center> </td>
                         <td className='w-130'><center><input type='radio' id='rbOtherDrugsOnceOrTwice_5' name='rbOtherDrugs_5' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbOtherDrugsSeveralTimes_5' name='rbOtherDrugs_5' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbOtherDrugsRepeatedly_5' name='rbOtherDrugs_5' className='add-only' value='Repeatedly' /></center> </td>


                    </tr>
                    <tr>
                        <td className='w-320'>
                            (6) Taken drugs to forget school, work, or family pressures?</td>
                        <td className='w-75'><center><input type='radio' id='rbOtherDrugsNever_6' name='rbOtherDrugs_6' className='add-only' value='Never' /></center> </td>
                         <td className='w-130'><center><input type='radio' id='rbOtherDrugsOnceOrTwice_6' name='rbOtherDrugs_6' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbOtherDrugsSeveralTimes_6' name='rbOtherDrugs_6' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbOtherDrugsRepeatedly_6' name='rbOtherDrugs_6' className='add-only' value='Repeatedly' /></center> </td>

                    </tr>
                    <tr>
                        <td className='w-320'>
                            (7)  Gotten into trouble with the law because of drugs?</td>
                        <td className='w-75'><center><input type='radio' id='rbOtherDrugsNever_7' name='rbOtherDrugs_7' className='add-only' value='Never' /></center> </td>
                         <td className='w-130'><center><input type='radio' id='rbOtherDrugsOnceOrTwice_7' name='rbOtherDrugs_7' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbOtherDrugsSeveralTimes_7' name='rbOtherDrugs_7' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbOtherDrugsRepeatedly_7' name='rbOtherDrugs_7' className='add-only' value='Repeatedly' /></center> </td>


                    </tr>
                    <tr>
                        <td className='w-320'>
                            (8)  Gotten really stoned or wiped out on drugs (more than just high)?</td>
                        <td className='w-75'><center><input type='radio' id='rbOtherDrugsNever_8' name='rbOtherDrugs_8' className='add-only' value='Never' /></center> </td>
                         <td className='w-130'><center><input type='radio' id='rbOtherDrugsOnceOrTwice_8' name='rbOtherDrugs_8' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbOtherDrugsSeveralTimes_8' name='rbOtherDrugs_8' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbOtherDrugsRepeatedly_8' name='rbOtherDrugs_8' className='add-only' value='Repeatedly' /></center> </td>

                    </tr>
                    <tr>
                        <td className='w-320'>
                            (9) Tried to talk a doctor into giving you some prescription drug (e.g. diet pills,pain killers, etc.)?</td>
                        <td className='w-75'><center><input type='radio' id='rbOtherDrugsNever_9' name='rbOtherDrugs_9' className='add-only' value='Never' /></center> </td>
                         <td className='w-130'><center><input type='radio' id='rbOtherDrugsOnceOrTwice_9' name='rbOtherDrugs_9' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbOtherDrugsSeveralTimes_9' name='rbOtherDrugs_9' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbOtherDrugsRepeatedly_9' name='rbOtherDrugs_9' className='add-only' value='Repeatedly' /></center> </td>


                    </tr>
                    <tr>
                        <td className='w-320'>
                            (10)  Spent your spare time in drug-related activities (e.g. buying, seeling, taking,etc.)?</td>
                        <td className='w-75'><center><input type='radio' id='rbOtherDrugsNever_10' name='rbOtherDrugs_10' className='add-only' value='Never' /></center> </td>
                         <td className='w-130'><center><input type='radio' id='rbOtherDrugsOnceOrTwice_10' name='rbOtherDrugs_10' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbOtherDrugsSeveralTimes_10' name='rbOtherDrugs_10' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbOtherDrugsRepeatedly_10' name='rbOtherDrugs_10' className='add-only' value='Repeatedly' /></center> </td>

                    </tr>
                    <tr>
                        <td className='w-320'>
                            (11)  Used drugs and alcohol at the same time?</td>
                        <td className='w-75'><center><input type='radio' id='rbOtherDrugsNever_11' name='rbOtherDrugs_11' className='add-only' value='Never' /></center> </td>
                         <td className='w-130'><center><input type='radio' id='rbOtherDrugsOnceOrTwice_11' name='rbOtherDrugs_11' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbOtherDrugsSeveralTimes_11' name='rbOtherDrugs_11' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbOtherDrugsRepeatedly_11' name='rbOtherDrugs_11' className='add-only' value='Repeatedly' /></center> </td>


                    </tr>
                    <tr>
                        <td className='w-320'>
                            (12) Continued to take a drug or drugs in order to avoid the pain of withdrawal?</td>
                        <td className='w-75'><center><input type='radio' id='rbOtherDrugsNever_12' name='rbOtherDrugs_12' className='add-only' value='Never' /></center> </td>
                         <td className='w-130'><center><input type='radio' id='rbOtherDrugsOnceOrTwice_12' name='rbOtherDrugs_12' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbOtherDrugsSeveralTimes_12' name='rbOtherDrugs_12' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbOtherDrugsRepeatedly_12' name='rbOtherDrugs_12' className='add-only' value='Repeatedly' /></center> </td>

                    </tr>
                    <tr>
                        <td className='w-320'>
                            (13)  Felt your drug use has kept you from getting what you want out of life?</td>
                        <td className='w-75'><center><input type='radio' id='rbOtherDrugsNever_13' name='rbOtherDrugs_13' className='add-only' value='Never' /></center> </td>
                         <td className='w-130'><center><input type='radio' id='rbOtherDrugsOnceOrTwice_13' name='rbOtherDrugs_13' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbOtherDrugsSeveralTimes_13' name='rbOtherDrugs_13' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbOtherDrugsRepeatedly_13' name='rbOtherDrugs_13' className='add-only' value='Repeatedly' /></center> </td>

                    </tr>
                    <tr>
                        <td className='w-320'>
                            (14)  Been accepted into a treatment program because of drug use?</td>
                        <td className='w-75'><center><input type='radio' id='rbOtherDrugsNever_14' name='rbOtherDrugs_14' className='add-only' value='Never' /></center> </td>
                         <td className='w-130'><center><input type='radio' id='rbOtherDrugsOnceOrTwice_14' name='rbOtherDrugs_14' className='add-only' value='OnceOrTwice' /></center> </td>
                        <td className='w-125'><center><input type='radio' id='rbOtherDrugsSeveralTimes_14' name='rbOtherDrugs_14' className='add-only' value='SeveralTimes' /></center> </td>
                        <td className='w-100'><center><input type='radio' id='rbOtherDrugsRepeatedly_14' name='rbOtherDrugs_14' className='add-only' value='Repeatedly' /></center> </td>

                    </tr>
                </table>
            </div>
        </form>

    )
}







